"use strict";

require("core-js/modules/es6.array.filter.js");
var _Object$keys = require("@babel/runtime-corejs2/core-js/object/keys");
var _Object$getOwnPropertySymbols = require("@babel/runtime-corejs2/core-js/object/get-own-property-symbols");
var _Object$getOwnPropertyDescriptor = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptor");
var _Object$getOwnPropertyDescriptors = require("@babel/runtime-corejs2/core-js/object/get-own-property-descriptors");
var _Object$defineProperties = require("@babel/runtime-corejs2/core-js/object/define-properties");
var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/defineProperty"));
var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));
var _model = _interopRequireDefault(require("./model"));
var _constant = require("./constant");
function cov_rd4spd81y() {
  var path = "/codebuild/output/src183882336/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/section/lib/reducer.js";
  var hash = "88e91705a4f7585670298f662c8690bfb546471e";
  var global = new Function("return this")();
  var gcv = "__coverage__";
  var coverageData = {
    path: "/codebuild/output/src183882336/src/bitbucket.org/secutix/gravity/apps/tnwi/temp/nucleo/section/lib/reducer.js",
    statementMap: {
      "0": {
        start: {
          line: 11,
          column: 35
        },
        end: {
          line: 14,
          column: 1
        }
      },
      "1": {
        start: {
          line: 16,
          column: 16
        },
        end: {
          line: 46,
          column: 1
        }
      },
      "2": {
        start: {
          line: 18,
          column: 2
        },
        end: {
          line: 45,
          column: 3
        }
      },
      "3": {
        start: {
          line: 20,
          column: 6
        },
        end: {
          line: 23,
          column: 8
        }
      },
      "4": {
        start: {
          line: 25,
          column: 6
        },
        end: {
          line: 25,
          column: 59
        }
      },
      "5": {
        start: {
          line: 26,
          column: 6
        },
        end: {
          line: 30,
          column: 8
        }
      },
      "6": {
        start: {
          line: 32,
          column: 6
        },
        end: {
          line: 35,
          column: 8
        }
      },
      "7": {
        start: {
          line: 37,
          column: 6
        },
        end: {
          line: 37,
          column: 96
        }
      },
      "8": {
        start: {
          line: 38,
          column: 6
        },
        end: {
          line: 42,
          column: 8
        }
      },
      "9": {
        start: {
          line: 44,
          column: 6
        },
        end: {
          line: 44,
          column: 19
        }
      }
    },
    fnMap: {
      "0": {
        name: "(anonymous_0)",
        decl: {
          start: {
            line: 16,
            column: 16
          },
          end: {
            line: 16,
            column: 17
          }
        },
        loc: {
          start: {
            line: 16,
            column: 83
          },
          end: {
            line: 46,
            column: 1
          }
        },
        line: 16
      }
    },
    branchMap: {
      "0": {
        loc: {
          start: {
            line: 16,
            column: 17
          },
          end: {
            line: 16,
            column: 70
          }
        },
        type: "default-arg",
        locations: [{
          start: {
            line: 16,
            column: 25
          },
          end: {
            line: 16,
            column: 70
          }
        }],
        line: 16
      },
      "1": {
        loc: {
          start: {
            line: 18,
            column: 2
          },
          end: {
            line: 45,
            column: 3
          }
        },
        type: "switch",
        locations: [{
          start: {
            line: 19,
            column: 4
          },
          end: {
            line: 23,
            column: 8
          }
        }, {
          start: {
            line: 24,
            column: 4
          },
          end: {
            line: 30,
            column: 8
          }
        }, {
          start: {
            line: 31,
            column: 4
          },
          end: {
            line: 35,
            column: 8
          }
        }, {
          start: {
            line: 36,
            column: 4
          },
          end: {
            line: 42,
            column: 8
          }
        }, {
          start: {
            line: 43,
            column: 4
          },
          end: {
            line: 44,
            column: 19
          }
        }],
        line: 18
      }
    },
    s: {
      "0": 0,
      "1": 0,
      "2": 0,
      "3": 0,
      "4": 0,
      "5": 0,
      "6": 0,
      "7": 0,
      "8": 0,
      "9": 0
    },
    f: {
      "0": 0
    },
    b: {
      "0": [0],
      "1": [0, 0, 0, 0, 0]
    },
    _coverageSchema: "1a1c01bbd47fc00a2c39e90264f33305004495a9",
    hash: "88e91705a4f7585670298f662c8690bfb546471e"
  };
  var coverage = global[gcv] || (global[gcv] = {});
  if (!coverage[path] || coverage[path].hash !== hash) {
    coverage[path] = coverageData;
  }
  var actualCoverage = coverage[path];
  {
    // @ts-ignore
    cov_rd4spd81y = function () {
      return actualCoverage;
    };
  }
  return actualCoverage;
}
cov_rd4spd81y();
function ownKeys(e, r) { var t = _Object$keys(e); if (_Object$getOwnPropertySymbols) { var o = _Object$getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return _Object$getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : _Object$getOwnPropertyDescriptors ? _Object$defineProperties(e, _Object$getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { _Object$defineProperty(e, r, _Object$getOwnPropertyDescriptor(t, r)); }); } return e; }
/*
  section = {
  loading : bool,
  error : bool,
  ...SectionType
}
*/
var sectionReducerInitialState = (cov_rd4spd81y().s[0]++, {
  LOADING: false,
  ERROR: false
});
cov_rd4spd81y().s[1]++;
var section = function section() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : (cov_rd4spd81y().b[0][0]++, (0, _assign.default)({}, sectionReducerInitialState));
  var action = arguments.length > 1 ? arguments[1] : undefined;
  cov_rd4spd81y().f[0]++;
  var newSection;
  cov_rd4spd81y().s[2]++;
  switch (action.type) {
    case _constant.SectionActionTypes.SECTION_BEFORE_LOAD:
      cov_rd4spd81y().b[1][0]++;
      cov_rd4spd81y().s[3]++;
      return {
        LOADING: true,
        ERROR: false
      };
    case _constant.SectionActionTypes.SECTION_LOAD_SUCCESS:
      cov_rd4spd81y().b[1][1]++;
      cov_rd4spd81y().s[4]++;
      newSection = _model.default.get(action.data, action.config);
      cov_rd4spd81y().s[5]++;
      return _objectSpread(_objectSpread({}, newSection), {}, {
        LOADING: false,
        ERROR: false
      });
    case _constant.SectionActionTypes.SECTION_LOAD_ERROR:
      cov_rd4spd81y().b[1][2]++;
      cov_rd4spd81y().s[6]++;
      return {
        LOADING: false,
        ERROR: true
      };
    case _constant.SectionActionTypes.SECTION_CHANGE_LANGUAGE:
      cov_rd4spd81y().b[1][3]++;
      cov_rd4spd81y().s[7]++;
      newSection = _model.default.changeLanguage(action.data, action.language, action.defaultLanguage);
      cov_rd4spd81y().s[8]++;
      return _objectSpread(_objectSpread({}, newSection), {}, {
        LOADING: false,
        ERROR: false
      });
    default:
      cov_rd4spd81y().b[1][4]++;
      cov_rd4spd81y().s[9]++;
      return state;
  }
};
var _default = exports.default = section;